// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1uLHn","addWidgetButton":"Header_addWidgetButton__3DJH4","dashboardTabs":"Header_dashboardTabs__2gjjM","active":"Header_active__3guqJ"};